// Compact, color-coded platform badges — used on the master inventory to show,
// at a glance, every marketplace a single piece is listed on. No external logos;
// on-brand monograms keep it fast and license-safe. Hover shows platform + price.
const STYLE = {
  "Chairish": { bg: "#0E7C61", mono: "C" },
  "1stDibs": { bg: "#111111", mono: "1D" },
  "AptDeco": { bg: "#1D4ED8", mono: "AD" },
  "Ruby Lane": { bg: "#9B1C2E", mono: "RL" },
  "Kaiyo": { bg: "#2E7D32", mono: "K" },
  "Pamono": { bg: "#6D28D9", mono: "P" },
  "Etsy": { bg: "#D5641C", mono: "Et" },
  "eBay": { bg: "#1D4ED8", mono: "eB" },
  "Facebook Marketplace": { bg: "#1877F2", mono: "FB" },
  "Instagram": { bg: "#C13584", mono: "IG" },
  "Local / In person": { bg: "#6B7280", mono: "L" },
  "Other": { bg: "#6B7280", mono: "•" },
};

export function PlatformBadge({ platform, price, size = 24 }) {
  const s = STYLE[platform] || { bg: "#8A867D", mono: (platform || "?").slice(0, 2) };
  const label = price ? `${platform} · $${Number(price).toLocaleString()}` : platform;
  return (
    <span
      title={label}
      aria-label={label}
      data-testid={`platform-badge-${platform}`}
      className="inline-flex items-center justify-center rounded-full font-bold text-white shrink-0 ring-1 ring-black/10"
      style={{ backgroundColor: s.bg, width: size, height: size, fontSize: size <= 22 ? 9 : 11, letterSpacing: "-0.03em" }}
    >
      {s.mono}
    </span>
  );
}

export function PlatformBadgeRow({ entries = [], size = 22 }) {
  const list = Array.isArray(entries) ? entries : [];
  if (!list.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid="platform-badges">
      {list.map((e) => (
        <PlatformBadge key={e.platform} platform={e.platform} price={e.price} size={size} />
      ))}
    </div>
  );
}
